import { render, staticRenderFns } from "./point_succ.vue?vue&type=template&id=2972cd0d&scoped=true&"
import script from "./point_succ.vue?vue&type=script&lang=js&"
export * from "./point_succ.vue?vue&type=script&lang=js&"
import style0 from "./point_succ.vue?vue&type=style&index=0&id=2972cd0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2972cd0d",
  null
  
)

export default component.exports